import React, { useState, useEffect } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withTranslation } from "react-i18next";
import SDK from '../../../config';
import { jwtDecode } from 'jwt-decode';
import avatar2 from '../../../assets/images/favicon.ico';

const ProfileMenu = ({ t }) => {
    const [menu, setMenu] = useState(false);
    const [membersData, setMembersData] = useState(null);

    const toggle = () => {
        setMenu(prevMenu => !prevMenu);
    };

    const handleLogout = () => {
        localStorage.removeItem("authUser");
        window.location.href = "/login";
    };

    return (
        <React.Fragment>
            <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block user-dropdown">
                <DropdownToggle tag="button" className="btn header-item waves-effect" id="page-header-user-dropdown">
                    {/* Conditionally render the profile image */}
                    {membersData && membersData.image ? (
                        <img className="rounded-circle header-profile-user me-1" src={`${SDK.BASE_URL}/uploads/${membersData.image}`} alt="Header Avatar" />
                    ) : (
                        <img className="rounded-circle header-profile-user me-1" src={avatar2} alt="Header Avatar" />
                    )}
                    <span className="d-none d-xl-inline-block ms-1 text-transform">Admin</span>
                    <i className="mdi mdi-chevron-down d-none ms-1 d-xl-inline-block"></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <DropdownItem href="#">
                        <i className="ri-user-line align-middle me-1"></i> {t('Profile')}
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem className="text-danger" onClick={handleLogout}>
                        <i className="ri-shut-down-line align-middle me-1 text-danger"></i> {t('Logout')}
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default withTranslation()(ProfileMenu);
